import { render, staticRenderFns } from "./HeaderLogoutModal.vue?vue&type=template&id=1a45e792&"
import script from "./HeaderLogoutModal.vue?vue&type=script&lang=js&"
export * from "./HeaderLogoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports